const DEFAULT_DELAY = 300;

const debounce = (func, timeout = DEFAULT_DELAY) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export default debounce;
